import React from 'react';
import { Link } from 'react-router-dom';
import {
  SiteLayout, FLAME, FLAME_2, INK, BODY, MUTED, BORDER, MONO,
  btnInk, btnFlame, btnGhost,
} from './SiteLayout';
import AdsTxtCheckerEmbed from './AdsTxtCheckerEmbed';

const CAPABILITIES = [
  { n: '01', title: 'Validate instantly', desc: 'ads.txt and sellers.json checks at your fingertips — results in seconds, not afternoons or EODs.' },
  { n: '02', title: 'Track approved inventory lists', desc: 'One place for all your approved inventory. Get notified the moment a supply partner drops your lines or an app disappears from the store.' },
  { n: '03', title: 'Analyze bid requests A→Z', desc: "See exactly what's missing in a bid request and what to fix to improve it — end to end, within seconds." },
  { n: '04', title: 'Fetch inventory info and crawl within minutes', desc: 'Pull your inventory info instantly — no manual work that drags on for hours or days.' },
  { n: '05', title: 'Monitor revenue, side by side', desc: 'Your numbers vs every partner\u2019s numbers individually, in one view — with a single one-time setup.' },
];

const BARS = [
  { partner: 54, you: 64 }, { partner: 72, you: 80 }, { partner: 40, you: 52 },
  { partner: 66, you: 58 }, { partner: 84, you: 92 }, { partner: 48, you: 44 },
  { partner: 76, you: 88 },
];

const STATS = [
  { big: '<5', small: ' min', label: 'per task — most in seconds' },
  { big: '11', small: '+', label: 'tools, one subscription' },
  { big: '1', small: ' free', label: 'tool free, no card needed' },
];

const card = {
  background: 'rgba(255,255,255,.85)', border: `1px solid ${BORDER}`,
  borderRadius: '14px', padding: '26px',
};

export default function HomePage4() {
  return (
    <SiteLayout>

      {/* ── HERO ── */}
      <section style={{ maxWidth: '1180px', margin: '0 auto', padding: '84px 32px 40px', textAlign: 'center' }}>
        <p style={{ fontFamily: MONO, fontSize: '20px', letterSpacing: '1.4px', color: FLAME, textTransform: 'uppercase', margin: 0 }}>
          AdOps TechHub Suite · 11+ tools · One login · One subscription · Priority support
        </p>

        <h1 className="ia-hero-h1" style={{
          fontSize: '62px', lineHeight: 1.02, fontWeight: 600, letterSpacing: '-1.8px',
          margin: '24px auto 0', maxWidth: '880px', textWrap: 'balance',
        }}>
          A full day of AdOps work, done in{' '}
          <span style={{ fontStyle: 'italic', color: FLAME }}>under 5 minutes per task</span>.
        </h1>

        <p style={{ fontSize: '21px', color: BODY, maxWidth: '620px', margin: '24px auto 0', lineHeight: 1.55 }}>
          We put quicker results at your team's fingertips — so they spend their time on optimization, not busywork.
        </p>

        <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', marginTop: '34px', flexWrap: 'wrap' }}>
          <Link to="/contact" className="ia-btn" style={btnInk}>Get started</Link>
          <Link to="/products" className="ia-btn" style={btnGhost}>See how it works</Link>
        </div>

        <p style={{ fontFamily: MONO, fontSize: '18px', color: FLAME, marginTop: '20px', fontWeight: 700 }}>
          11+ AdOps tasks that used to eat hours — the coverage of an extra hire.
        </p>

        {/* ── Product preview (glass panel) ── */}
        <div style={{
          margin: '52px auto 0', maxWidth: '940px',
          background: 'rgba(255,255,255,.62)', border: '2px solid rgba(10,10,10,.9)',
          borderRadius: '20px', padding: '18px', backdropFilter: 'blur(14px)',
          boxShadow: '0 30px 70px -28px rgba(40,30,18,.4), 0 2px 10px rgba(40,30,18,.06)',
        }}>
          <div className="ia-grid-2" style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '16px', textAlign: 'left' }}>

            {/* Revenue vs partners */}
            <div style={{ background: '#fff', border: '2px solid #ece8df', borderRadius: '14px', padding: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px', flexWrap: 'wrap', gap: '6px' }}>
                <span style={{ fontSize: '16px', fontWeight: 600 }}>Revenue vs partners</span>
                <span style={{ fontFamily: MONO, fontSize: '12px', color: '#16a34a', display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ width: 6, height: 6, background: '#16a34a', borderRadius: '50%', display: 'inline-block' }} />
                  Live · One-time setup · Runs everyday
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '9px', height: '120px' }}>
                {BARS.map((b, i) => (
                  <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', gap: '3px', height: '100%' }}>
                    <div style={{ height: `${b.partner}%`, background: '#e2ddd2', borderRadius: '4px' }} />
                    <div style={{ height: `${b.you}%`, background: FLAME, borderRadius: '4px' }} />
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', gap: '18px', marginTop: '14px', fontFamily: MONO, flexWrap: 'wrap' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontWeight: 600 }}>
                  <span style={{ width: 8, height: 8, background: FLAME, borderRadius: '2px' }} />Your numbers
                </span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontWeight: 600 }}>
                  <span style={{ width: 8, height: 8, background: '#e2ddd2', borderRadius: '2px' }} />Partner reported numbers
                </span>
              </div>
              <div style={{ fontSize: '20px', fontWeight: 600, marginTop: '18px' }}>Discrepancy Monitor</div>
            </div>

            {/* Right stack */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ background: '#fff', border: '2px solid #ece8df', borderRadius: '14px', padding: '18px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', gap: '6px' }}>
                  <span style={{ fontFamily: MONO, fontSize: '15px', color: INK }}>Bid Request Analyzed</span>
                  <span style={{ fontFamily: MONO, fontSize: '10px', color: '#16a34a' }}>done 0.8s</span>
                </div>
                <div style={{ height: '7px', background: '#f0ece3', borderRadius: '4px', overflow: 'hidden', marginBottom: '9px' }}>
                  <div style={{ width: '100%', height: '100%', background: `linear-gradient(90deg, ${FLAME}, #ff8254)` }} />
                </div>
                <div style={{ fontFamily: MONO, fontSize: '12px', color: MUTED, fontWeight: 600, lineHeight: 1.6 }}>
                  3 anomalies detected<br />Missing GDPR / CCPA compliance<br />Schain unauthorized
                </div>
              </div>

              <div style={{ background: '#fff', border: '2px solid #ece8df', borderRadius: '14px', padding: '18px' }}>
                <div style={{ fontFamily: MONO, fontSize: '15px', color: INK, marginBottom: '12px' }}>Approved-list Tracker</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '9px', marginBottom: '9px' }}>
                  <span style={{ width: 7, height: 7, background: FLAME, borderRadius: '50%', flex: 'none' }} />
                  <span style={{ fontSize: '12px', color: BODY, fontWeight: 800 }}>
                    partner-x.com <span style={{ color: MUTED, fontWeight: 600 }}>— your line removed</span>
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
                  <span style={{ width: 7, height: 7, background: '#c9a227', borderRadius: '50%', flex: 'none' }} />
                  <span style={{ fontSize: '12px', color: BODY, fontWeight: 800 }}>
                    app-y <span style={{ color: MUTED, fontWeight: 600 }}>— gone from store</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FREE TOOL: live ads.txt checker ── */}
      <section style={{ maxWidth: '1040px', margin: '0 auto', padding: '8px 32px 8px' }}>
        <AdsTxtCheckerEmbed />
      </section>

      {/* ── STAT ROW ── */}
      <section style={{ maxWidth: '1180px', margin: '0 auto', padding: '48px 32px 72px' }}>
        <div className="ia-grid-3" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', textAlign: 'center' }}>
          {STATS.map(({ big, small, label }) => (
            <div key={label} style={{
              padding: '30px 20px', border: '4px double rgba(230,225,215,.92)',
              borderRadius: '18px', background: '#efece5',
            }}>
              <div style={{ fontSize: '50px', fontWeight: 600, letterSpacing: '-2px', lineHeight: 1 }}>
                {big}<span style={{ fontSize: '20px', color: FLAME }}>{small}</span>
              </div>
              <div style={{ fontSize: '15px', color: '#7a746a', marginTop: '10px', fontWeight: 600 }}>{label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CAPABILITIES ── */}
      <section style={{ maxWidth: '1180px', margin: '0 auto', padding: '0 32px 30px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <p style={{ fontFamily: MONO, fontSize: '18px', letterSpacing: '1.5px', color: FLAME, textTransform: 'uppercase', margin: 0 }}>
            What the AdTech Hub does for you
          </p>
          <h2 style={{ fontSize: '32px', fontWeight: 600, letterSpacing: '-.8px', marginTop: '12px' }}>
            Everything your AdOps team keeps chasing — now unimaginably faster, all in one place.
          </h2>
        </div>

        <div className="ia-grid-3" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '18px' }}>
          {CAPABILITIES.map(({ n, title, desc }) => (
            <div key={n} style={card}>
              <div style={{ fontFamily: MONO, fontSize: '11px', color: FLAME }}>{n}</div>
              <h3 style={{ fontSize: '20px', fontWeight: 600, marginTop: '12px', marginBottom: 0 }}>{title}</h3>
              <p style={{ fontSize: '16px', color: BODY, lineHeight: 1.55, marginTop: '9px' }}>{desc}</p>
            </div>
          ))}

          {/* Dark card */}
          <div style={{ ...card, background: INK, color: '#f6f5f2', border: `1px solid ${INK}` }}>
            <div style={{ fontFamily: MONO, fontSize: '11px', color: FLAME_2 }}>06</div>
            <h3 style={{ fontSize: '20px', fontWeight: 600, marginTop: '12px', marginBottom: 0 }}>Fetch Engine</h3>
            <p style={{ fontSize: '16px', color: '#b8b2a7', lineHeight: 1.55, marginTop: '9px' }}>
              Pull your ad-server and partner data in one place — no logging into a dozen dashboards.
            </p>
            <Link to="/products" style={{ fontSize: '14px', color: FLAME_2, marginTop: '16px', display: 'inline-block', textDecoration: 'none' }}>
              + more tools in the suite →
            </Link>
          </div>
        </div>
      </section>

      {/* ── PRICING TEASER ── */}
      <section style={{ maxWidth: '1180px', margin: '0 auto', padding: '50px 32px 0' }}>
        <div style={{
          padding: '38px 42px', border: '4px double #e6e1d7', borderRadius: '18px',
          background: 'rgba(239,236,229,.85)', backdropFilter: 'blur(6px)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '30px', flexWrap: 'wrap',
        }}>
          <div>
            <h2 style={{ fontSize: '24px', fontWeight: 600, letterSpacing: '-.4px', margin: 0 }}>One tool free, forever.</h2>
            <p style={{ fontSize: '15px', color: BODY, marginTop: '9px', maxWidth: '560px', lineHeight: 1.55 }}>
              Everything else lives under a single monthly subscription — one login, one bill, priority support included. No trials, no surprises.
            </p>
          </div>
          <Link to="/contact" className="ia-btn" style={{ ...btnInk, flex: 'none' }}>See pricing →</Link>
        </div>
      </section>

      {/* ── CLOSING CTA ── */}
      <section style={{ marginTop: '72px', padding: '80px 32px', textAlign: 'center', background: INK, color: '#f6f5f2' }}>
        <h2 style={{ fontSize: '38px', fontWeight: 600, letterSpacing: '-1px', margin: 0 }}>Give your team its hours back.</h2>
        <p style={{ fontSize: '16px', color: '#a8a297', marginTop: '14px' }}>
          Start with one free tool · upgrade to the full suite whenever you're ready.
        </p>
        <Link to="/contact" className="ia-btn" style={{ ...btnFlame, marginTop: '26px' }}>Get started free</Link>
      </section>

    </SiteLayout>
  );
}
